import Illustration from '../components/Illustration/Illustration';

const Shroom = Illustration(
  'shroom',
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M64.476 38.16c-23.384 15.376-32.418 4.748-32.418 4.748s-6.016-28.28 10.437-38.85C58.95-6.513 82.751 7.754 82.751 7.754s7.748 11.614-14.712 27.937c-.625.454-1.24.89-1.846 1.31 3.85 7.038 8.565 16.493 12.676 27.142 3.784-4.201 7.345-7.017 9-8.236-5.484-4.838-3.461-7.966-3.461-7.966s6.14-2.256 10.323 1.32c4.183 3.577 3.264 9.485 3.264 9.485s-2.5 3.034-8.722-1.693a26.376 26.376 0 0 1-.843-.668c-3.57 3.03-6.567 6.072-9.044 9.113 7.106 18.824 12.165 41.149 7.27 60.405 9.588 10.104 21.738 18.522 32.354 24.254h-16.001c-7.67-5.701-13.907-11.237-18.926-16.581-2.556 6.033-6.31 11.635-11.549 16.571H34.455c17.702-9.684 29.979-20.911 37.18-33.524-11.541-21.784-3.57-39.175 4.962-49.81-2.467-9.15-6.53-18.712-12.121-28.654Zm10.429 71.826c-6.775-12.782-7.926-27.04 2.15-41.408 3.72 14.968 3.107 28.817-2.15 41.408Z"
  />
);

export default Shroom;
